import { PrescriptionRepository } from "@/domain/repository/prescription-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SendPatientMessageUsecase {
  constructor(private readonly prescriptionRepo: PrescriptionRepository) {}

  async execute(
    patientUuid: string,
    title: string,
    content: string,
  ): Promise<SATResult<void, SATError>> {
    return this.prescriptionRepo.sendPatientMessage(patientUuid, title, content);
  }
}
